/**
 * Placeholder field definitions for the PDF Placeholder Editor.
 * Shared between RAMS and TBT document systems.
 *
 * Each field has:
 * - value: the field key used in placeholder_config and backend resolution
 * - label: human-readable label shown in the editor
 * - category: grouping for the field selector dropdown
 * - type: 'text' or 'image'
 */

var PLACEHOLDER_CATEGORIES = [
  { key: 'company', label: 'Company' },
  { key: 'project', label: 'Project' },
  { key: 'subcontractor', label: 'Subcontractor' },
  { key: 'ae', label: 'A&E' },
  { key: 'rams_listings', label: 'RAMS Listings' },
  { key: 'rams_checkboxes', label: 'RAMS Checkboxes' },
  { key: 'signing', label: 'Signing' },
]

var PLACEHOLDER_FIELDS = [
  // Company fields (from team settings)
  { value: 'company.logo', label: 'Company Logo', category: 'company', type: 'image' },
  { value: 'company.name', label: 'Company Name', category: 'company', type: 'text' },
  { value: 'company.phone', label: 'Phone', category: 'company', type: 'text' },
  { value: 'company.email', label: 'Email', category: 'company', type: 'text' },
  { value: 'company.website', label: 'Website', category: 'company', type: 'text' },
  { value: 'company.vat', label: 'VAT Number', category: 'company', type: 'text' },
  { value: 'company.address', label: 'Address', category: 'company', type: 'text' },
  { value: 'company.postcode', label: 'Postcode', category: 'company', type: 'text' },
  { value: 'company.city', label: 'City', category: 'company', type: 'text' },

  // Project fields
  { value: 'project.title', label: 'Project Title', category: 'project', type: 'text' },
  { value: 'project.reference', label: 'Project Reference', category: 'project', type: 'text' },
  { value: 'project.address', label: 'Project Address', category: 'project', type: 'text' },
  { value: 'project.client.name', label: 'Client Name', category: 'project', type: 'text' },
  { value: 'project.client.site', label: 'Client Site', category: 'project', type: 'text' },
  { value: 'project.start_date', label: 'Project Start Date', category: 'project', type: 'text' },
  { value: 'project.end_date', label: 'Project End Date', category: 'project', type: 'text' },
  { value: 'project.manager', label: 'Project Manager', category: 'project', type: 'text' },
  { value: 'project.manager.phone', label: 'Project Manager Phone', category: 'project', type: 'text' },
  { value: 'project.manager.email', label: 'Project Manager Email', category: 'project', type: 'text' },
  { value: 'project.contracts_manager', label: 'Contracts Manager', category: 'project', type: 'text' },
  { value: 'project.contracts_manager.phone', label: 'Contracts Manager Phone', category: 'project', type: 'text' },
  { value: 'project.contracts_manager.email', label: 'Contracts Manager Email', category: 'project', type: 'text' },
  { value: 'project.supervisor', label: 'Supervisor', category: 'project', type: 'text' },
  { value: 'project.supervisor.phone', label: 'Supervisor Phone', category: 'project', type: 'text' },
  { value: 'project.supervisor.email', label: 'Supervisor Email', category: 'project', type: 'text' },

  // Subcontractor fields
  { value: 'subcontractor.name', label: 'Subcontractor Name', category: 'subcontractor', type: 'text' },
  { value: 'subcontractor.contact_name', label: 'Contact Name', category: 'subcontractor', type: 'text' },
  { value: 'subcontractor.email', label: 'Email Address', category: 'subcontractor', type: 'text' },
  { value: 'subcontractor.phone', label: 'Phone Number', category: 'subcontractor', type: 'text' },
  { value: 'subcontractor.trade', label: 'Trade / Skill', category: 'subcontractor', type: 'text' },

  // A&E fields
  { value: 'ae.name', label: 'A&E Name', category: 'ae', type: 'text' },
  { value: 'ae.address', label: 'A&E Address', category: 'ae', type: 'text' },

  // RAMS Listing fields (multi-value, rendered as vertical list with green ticks)
  { value: 'rams.access_equipment_list', label: 'Equipment', category: 'rams_listings', type: 'list' },
  { value: 'rams.paints_list', label: 'Paints', category: 'rams_listings', type: 'list' },
  { value: 'rams.ppe_listing', label: 'PPE', category: 'rams_listings', type: 'list' },
  { value: 'rams.training_list', label: 'Training', category: 'rams_listings', type: 'list' },
  { value: 'rams.spray_timing', label: 'Working Hours', category: 'rams_listings', type: 'text' },
  { value: 'rams.scope', label: 'Scope', category: 'rams_listings', type: 'text' },
  { value: 'rams.site_access', label: 'Site Access', category: 'rams_listings', type: 'text' },
  { value: 'rams.deliveries', label: 'Deliveries', category: 'rams_listings', type: 'text' },
  { value: 'rams.welfare', label: 'Welfare', category: 'rams_listings', type: 'text' },
  { value: 'rams.tasks_list', label: 'Tasks', category: 'rams_listings', type: 'list' },
  { value: 'rams.coshh_list', label: 'COSHH', category: 'rams_listings', type: 'list' },
  { value: 'rams.induction_requirements', label: 'Induction Requirements', category: 'rams_listings', type: 'text' },

  // Signing fields
  { value: 'signature', label: 'Signature Image', category: 'signing', type: 'image' },
  { value: 'signed_date', label: 'Signed Date', category: 'signing', type: 'text' },
  { value: 'signed_time', label: 'Signed Time', category: 'signing', type: 'text' },
  { value: 'valid_from', label: 'Valid From', category: 'signing', type: 'text' },
  { value: 'valid_to', label: 'Valid To', category: 'signing', type: 'text' },
  { value: 'duration_period', label: 'Duration Period', category: 'signing', type: 'text' },
  { value: 'current_date', label: 'Current Date', category: 'signing', type: 'text' },
]

var DEFAULT_PLACEHOLDER = {
  font_size: 10,
  font_color: '#000000',
  align: 'left',
  width: 50,
  height: 10,
}

var DEFAULT_SIGNATURE_PLACEHOLDER = {
  font_size: 10,
  font_color: '#000000',
  align: 'left',
  width: 40,
  height: 20,
}

var DEFAULT_LIST_PLACEHOLDER = {
  font_size: 8,
  font_color: '#000000',
  align: 'left',
  width: 60,
  height: 40,
}

function getFieldDefinition(fieldValue) {
  for (var i = 0; i < PLACEHOLDER_FIELDS.length; i++) {
    if (PLACEHOLDER_FIELDS[i].value === fieldValue) {
      return PLACEHOLDER_FIELDS[i]
    }
  }
  return null
}

function getFieldsByCategory(category) {
  return PLACEHOLDER_FIELDS.filter(function(field) {
    return field.category === category
  })
}

/**
 * Sanitize a field key by removing special characters and converting to lowercase
 */
function sanitizeFieldKey(text) {
  var key = text.toLowerCase()
  key = key.replace(/[^a-z0-9\s_-]/g, '')
  key = key.replace(/\s+/g, '_')
  return key
}

// Flag to track if checkbox fields have been loaded
var checkboxFieldsLoaded = false

/**
 * Load RAMS checkbox fields from the API and add them to PLACEHOLDER_FIELDS
 * This should be called when initializing the placeholder editor
 * Pass the getRamsListItems function from HttpRequests/ramsControlCentre
 */
function loadRamsCheckboxFields(getRamsListItemsFn) {
  // Only load once
  if (checkboxFieldsLoaded) {
    return Promise.resolve([])
  }

  return getRamsListItemsFn().then(function(response) {
    var lists = response.data.data || {}
    var checkboxFields = []

    // PPE checkboxes
    if (lists.ppe && Array.isArray(lists.ppe)) {
      lists.ppe.forEach(function(item) {
        var itemValue = typeof item === 'string' ? item : (item.value || item.key)
        checkboxFields.push({
          value: 'rams.ppe.' + sanitizeFieldKey(itemValue),
          label: 'PPE: ' + itemValue,
          category: 'rams_checkboxes',
          type: 'text'
        })
      })
    }

    // Equipment checkboxes
    if (lists.access && Array.isArray(lists.access)) {
      lists.access.forEach(function(item) {
        var itemValue = typeof item === 'string' ? item : (item.value || item.key)
        checkboxFields.push({
          value: 'rams.access.' + sanitizeFieldKey(itemValue),
          label: 'Equipment: ' + itemValue,
          category: 'rams_checkboxes',
          type: 'text'
        })
      })
    }

    // Training checkboxes
    if (lists.training && Array.isArray(lists.training)) {
      lists.training.forEach(function(item) {
        var itemValue = typeof item === 'string' ? item : (item.value || item.key)
        checkboxFields.push({
          value: 'rams.training.' + sanitizeFieldKey(itemValue),
          label: 'Training: ' + itemValue,
          category: 'rams_checkboxes',
          type: 'text'
        })
      })
    }

    // Equipment checkboxes
    if (lists.equipment && Array.isArray(lists.equipment)) {
      lists.equipment.forEach(function(item) {
        var itemValue = typeof item === 'string' ? item : (item.value || item.key)
        checkboxFields.push({
          value: 'rams.equipment.' + sanitizeFieldKey(itemValue),
          label: 'Equipment: ' + itemValue,
          category: 'rams_checkboxes',
          type: 'text'
        })
      })
    }

    // Task checkboxes
    if (lists.task && Array.isArray(lists.task)) {
      lists.task.forEach(function(item) {
        var itemValue = typeof item === 'string' ? item : (item.value || item.key)
        checkboxFields.push({
          value: 'rams.task.' + sanitizeFieldKey(itemValue),
          label: 'Task: ' + itemValue,
          category: 'rams_checkboxes',
          type: 'text'
        })
      })
    }

    // COSHH checkboxes
    if (lists.coshh && Array.isArray(lists.coshh)) {
      lists.coshh.forEach(function(item) {
        var itemValue = typeof item === 'string' ? item : (item.value || item.key)
        checkboxFields.push({
          value: 'rams.coshh.' + sanitizeFieldKey(itemValue),
          label: 'COSHH: ' + itemValue,
          category: 'rams_checkboxes',
          type: 'text'
        })
      })
    }

    // Add checkbox fields to PLACEHOLDER_FIELDS
    PLACEHOLDER_FIELDS.push.apply(PLACEHOLDER_FIELDS, checkboxFields)

    // Mark as loaded to prevent duplicates
    checkboxFieldsLoaded = true

    return checkboxFields
  })
}

module.exports = {
  PLACEHOLDER_CATEGORIES: PLACEHOLDER_CATEGORIES,
  PLACEHOLDER_FIELDS: PLACEHOLDER_FIELDS,
  DEFAULT_PLACEHOLDER: DEFAULT_PLACEHOLDER,
  DEFAULT_SIGNATURE_PLACEHOLDER: DEFAULT_SIGNATURE_PLACEHOLDER,
  DEFAULT_LIST_PLACEHOLDER: DEFAULT_LIST_PLACEHOLDER,
  getFieldDefinition: getFieldDefinition,
  getFieldsByCategory: getFieldsByCategory,
  loadRamsCheckboxFields: loadRamsCheckboxFields,
  sanitizeFieldKey: sanitizeFieldKey,
}
